/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Unavailable_GroupInputs */



/**
* | output |
* | --- |
* | "Unavailable group" |
*
* @param {Team_Share_Unavailable_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_unavailable_group = /** @type {((inputs?: Team_Share_Unavailable_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Unavailable_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Unavailable group")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unavailable group")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unavailable group")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Unavailable group")
	if (locale === "es") return /** @type {LocalizedString} */ ("Unavailable group")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Unavailable group")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Unavailable group")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Unavailable group")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Unavailable group")
	return /** @type {LocalizedString} */ ("Unavailable group")
});